module.exports = __webpack_public_path__ + "static/media/mastercard-logo.a3488ddb.svg";